export const azureAuthConfig = {
    auth: {
        clientId: import.meta.env.VITE_AZURE_CLIENTID_DEV, // Update Application (client) ID
        authority: import.meta.env.VITE_TENANT_ID, // Endpoint > OAuth 2.0 authorization endpoint (v2)
        redirectUri: '/dashboard',  // After login the azure will redirect the user back to this location,
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    }
};
